export default [{
    path: '/empresa',
    name: 'empresa',
    component: () =>
        import ('@/views/pages/empresa/Empresa.vue'),
    meta: {
        layout: 'full',
        resource: 'Empresa',
        action: 'ver-empresa',
    },
}, ]
